import(/* webpackMode: "eager" */ "/home/runner/work/portfolio/portfolio/src/app/global-error.tsx")